import { useState, useEffect, useCallback } from 'react';
import {
  api,
  ContributorArcheDashboardResult,
  ContributorArcheDashboardSummary,
  ContributorArcheMetric,
} from '../../lib/api';

interface UseContributorDashboardReturn {
  summary: ContributorArcheDashboardSummary | null;
  arches: ContributorArcheMetric[];
  loading: boolean;
  error: string | null;
  refresh: () => void;
}

export function useContributorDashboard(): UseContributorDashboardReturn {
  const [result, setResult] = useState<ContributorArcheDashboardResult | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchDashboard = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const data = await api.getContributorArcheDashboard();
      setResult(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch dashboard');
      setResult(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchDashboard();
  }, [fetchDashboard]);

  return {
    summary: result?.summary ?? null,
    arches: result?.arches ?? [],
    loading,
    error,
    refresh: fetchDashboard,
  };
}
